/** basic.faultRecords */
export default {
    backFaultRecords: "Назад к записям неисправностей устройства",
    handleStatePla: "Выберите статус обработки",
    handleDeviceState: "Выберите состояние устройства",
    historicalRecord: "История",
    handle: "Обработано",
    noHandle: "Не обработано",
}

